export default "__VITE_ASSET__0bceea5d__"